(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-filter.off').forEach((el) => {
    el.classList.remove('off')
  })
  document.querySelectorAll('.js-filter').forEach((el) => {
    if(el.querySelectorAll('label:not(.facet-checkbox--disabled)').length<=1) el.classList.add('off')
  })

  const mediaSliders = document.querySelectorAll('.productThumb--collection .productThumb__media--mobile > .swiper');
  if (mediaSliders && window.matchMedia("(max-width: 767px)").matches) {
    mediaSliders.forEach((mediaSlider) => {
      const swiperCollThumbMedia = new Swiper(mediaSlider, {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
      });
    });
  }
})

  } catch(e) { console.error(e); }
})();
})();
